import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import type {
  ModelTestCaseStep,
  PutDraftTestCaseSteps
} from '@eggplant/types'
import type {
  ReactElement,
  ReactNode
} from 'react'

interface Steps {
  steps: ModelTestCaseStep[]
}

interface Props {
  testcaseId: string
  params: Steps
  spinnerSize?: number
  children?: (response: PutDraftTestCaseSteps) => ReactElement | ReactNode
  onSuccess?: (response: PutDraftTestCaseSteps) => void
  onError?: (error: any) => void
}

const PutTestCaseDraft = ({
  testcaseId,
  params,
  spinnerSize,
  children,
  onSuccess,
  onError
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/${testcaseId}/draft`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      spinnerSize={spinnerSize}
      url={url}
    />
  )
}

export default PutTestCaseDraft
